var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-reception"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("AI")])])],1),_c('el-row',[_c('el-col',[_c('AiForm')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }